import { css, cx } from "@emotion/css";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import type { MouseEvent } from "react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { UserAvatar } from "src/components/Default/Avatar";
import { ProfileActionsList } from "src/components/GlobalSearch/Profile/ProfileActionsList";
import { getUserInfo } from "src/hooks/useUser";
import ProfileIcon from "src/images/Icons/newIcons/userProfile/profile.svg";
import isMobile from "../../../helpers/isMobile";
import { IconButton } from "../../Default/LekUI/Button";
import { SwipeableContent } from "../../Default/LekUI/SwipableDrawer";
import { Tooltip } from "../../Default/LekUI/Tooltip";
import Popper from "../../NewComponents/Default/Popper";
import { PesInfo } from "../PesInfo";

export const ProfilePopup = () => {
	const userInfo = getUserInfo();
	const { t } = useTranslation();
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

	useEffect(() => {
		setAnchorEl(null);
	}, []);

	const onProfileClick = (e: MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(e.currentTarget);
	};

	const close = () => {
		setAnchorEl(null);
	};

	const renderContent = () => {
		if (isMobile()) {
			return (
				<SwipeableContent isOpen={!!anchorEl} onClose={close}>
					<div className="m-16">
						<PesInfo />
					</div>
					<div className="ofy-auto">{!!anchorEl && <ProfileActionsList />}</div>
				</SwipeableContent>
			);
		}

		return (
			<Popper className="" anchorEl={anchorEl}>
				<ClickAwayListener onClickAway={close}>
					<div
						className={cx(
							"popper of-auto py-0",
							css`
                max-height: 400px;
                max-width: min(240px, 1000%);
              `,
						)}
					>
						<ProfileActionsList />
					</div>
				</ClickAwayListener>
			</Popper>
		);
	};

	const renderTrigger = () => {
		if (userInfo?.avatarUrl) {
			return (
				<div data-test-id="user-menu-button">
					<UserAvatar
						avatarClassName="avatar-36"
						className="ml-2"
						onClick={onProfileClick}
					/>
				</div>
			);
		}

		return (
			<IconButton
				isActive={!!anchorEl}
				onClick={onProfileClick}
				data-test-id="user-menu-button"
			>
				<ProfileIcon className="icon-big" />
			</IconButton>
		);
	};

	return (
		<>
			<Tooltip title={t("tooltips.profile")}>{renderTrigger()}</Tooltip>
			{renderContent()}
		</>
	);
};
